import { useState, useMemo } from 'react';
import {
  getPhoneCodeSelectableOptions,
  getOccupationsSelectableOptions,
} from '../utils';
import { AddressInfo } from '../components/AddressField/AddressField.types';

export function useAttestationForm() {
  const [userInfo, setUserInfo] = useState({
    firstName: '',
    lastName: '',
    phoneCode: '',
    phoneNumber: '',
    occupation: '',
    address: '',
  });

  const [addressInfo, setAddressInfo] = useState<AddressInfo>({
    address: '',
    building: '',
    unit: '',
    street: '',
    city: '',
    postalCode: '',
  });

  const [addressInfoErrors, setAddressInfoErrors] = useState<AddressInfo>({
    address: '',
    building: '',
    unit: '',
    street: '',
    city: '',
    postalCode: '',
  });

  const [phoneNumberError, setPhoneNumberError] = useState('');
  const [isPep, setIsPep] = useState<boolean>(false);
  const [selectedImageSource, setSelectedImageSource] = useState<string>();
  const [focusFirstInputField, setFocusFirstInputField] =
    useState<boolean>(false);
  const occupations = useMemo(getOccupationsSelectableOptions, []);
  const phoneCodeList = useMemo(getPhoneCodeSelectableOptions, []);

  const handleUserInfoFieldChange = (field: string, value: string) => {
    setUserInfo((prev) => ({ ...prev, [field]: value }));
  };

  return {
    userInfo,
    addressInfo,
    addressInfoErrors,
    isPep,
    focusFirstInputField,
    phoneNumberError,
    occupations,
    phoneCodeList,
    selectedImageSource,
    setUserInfo,
    setIsPep,
    setFocusFirstInputField,
    setAddressInfo,
    setAddressInfoErrors,
    setPhoneNumberError,
    setSelectedImageSource,
    handleUserInfoFieldChange,
  };
}

export default useAttestationForm;
